import React from 'react';
import { TextField } from '../textfield/textfield';
import { Slider } from '../slider/slider';
import { cn } from '../../../../utils/tailwind';
import { TextFieldWithSliderWrapper } from './wrapper/textfield-with-slider-wrapper';
import { TextFieldWithSliderProps } from './textfield-with-slider.types';

const defaultSliderWrapperClassName =
    '[&_.MuiSlider-rail]:bg-border [&_.MuiSlider-rail]:opacity-100 [&_.MuiSlider-root]:h-[6px] [&_.MuiSlider-root]:text-brand-primary [&_.MuiSlider-thumb.Mui-active]:shadow-[0_0_0_12px_rgba(51,71,255,0.19)] [&_.MuiSlider-thumb.Mui-focusVisible]:shadow-[0_0_0_8px_rgba(51,71,255,0.13)] [&_.MuiSlider-thumb:hover]:shadow-[0_0_0_8px_rgba(51,71,255,0.13)] [&_.MuiSlider-thumb]:h-[18px] [&_.MuiSlider-thumb]:w-[18px] [&_.MuiSlider-thumb]:border-2 [&_.MuiSlider-thumb]:border-solid [&_.MuiSlider-thumb]:border-body [&_.MuiSlider-thumb]:bg-brand-primary [&_.MuiSlider-thumb]:shadow-[0_2px_4px_rgba(0,0,0,0.2)] [&_.MuiSlider-track]:border-0 [&_.MuiSlider-track]:bg-gradient-to-r [&_.MuiSlider-track]:from-brand-primary [&_.MuiSlider-track]:to-brand-primary-light';

export const TextFieldWithSlider: React.FC<TextFieldWithSliderProps> = ({
    sliderValue,
    sliderPadding,
    sliderProps,
    textFieldProps,
    className,
    sliderWrapperClassName,
    sliderWrapperStyle,
    withDefaultSliderStyles = true,
}) => (
    <TextFieldWithSliderWrapper className={className}>
        <TextField {...textFieldProps} />
        <div
            className={cn(withDefaultSliderStyles && defaultSliderWrapperClassName, sliderWrapperClassName)}
            style={{ padding: sliderPadding ?? '0 2.5rem', ...sliderWrapperStyle }}
        >
            <Slider value={sliderValue} {...sliderProps} />
        </div>
    </TextFieldWithSliderWrapper>
);
